import React from "react";
import { stripScheme } from "../../../lib/projectHelpers";

const ProjectThumb = ({ project }) => {
  if (project.thumb) {
    return (
      <img
        src={project.thumb}
        alt={project.name}
        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        loading="lazy"
        draggable="false"
      />
    );
  }
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(212,175,55,0.18), transparent 65%)",
        }}
      />
      <div className="relative text-[10px] tracking-[0.4em] uppercase text-gold mb-3">
        Open Slot
      </div>
      <div className="relative font-serif text-2xl text-themed max-w-[260px]">
        Your brand could be here.
      </div>
    </div>
  );
};

const ProjectCard = ({ project, onOpen }) => (
  <button
    data-testid={`showcase-grid-card-${project.id}`}
    onClick={() => onOpen(project)}
    className="glass-card text-left group block overflow-hidden p-0"
    style={{ borderRadius: "14px" }}
  >
    <div className="aspect-[16/10] overflow-hidden bg-black relative">
      <ProjectThumb project={project} />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    </div>
    <div className="p-6">
      <div className="font-serif text-xl text-themed leading-tight">
        {project.name}
      </div>
      <div className="mt-2 text-[10px] tracking-[0.25em] uppercase text-gold/70">
        {project.url ? stripScheme(project.url) : "Coming Soon"}
      </div>
      <div className="mt-4 flex flex-wrap gap-1.5">
        {project.tags.slice(0, 3).map((t) => (
          <span
            key={t}
            className="text-[9px] tracking-[0.2em] uppercase text-themed-muted border-l border-gold/40 pl-2"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </button>
);

export default ProjectCard;
